export var phoneNumberMask = {
    mask: '+375(__)___-__-__',
    replacement: { _: /\d/ },
    showMask: true,
};
export var approvalCodeMask = {
    mask: '_-_-_-_',
    replacement: { _: /\d/ },
    showMask: true,
};
export var dateMask = {
    mask: '__-__-____',
    replacement: { _: /\d/ },
    showMask: true,
};
export var accountMask = {
    mask: 'BY__ ____ ____ ____ ____ ____ ____',
    replacement: { _: /\d/ },
    showMask: true,
};
